<template>
    <div class="news-box" >
        <div class="banner-box">
            <img src="./../assets/img/banner_news.jpg" alt="">
            <ul class="nav-list-box">
                <li v-for="(item,index) in nav" :key="index" :class="{active:form.newsclass==item.newsclass}" @click="updata(item.newsclass)">
                    {{item.text}}
                </li>
            </ul>
        </div>
        <ul class="news-list">
            <li v-for="item in newslist" :key="item.id">
                <router-link :to="{name:'NewsDetail',params:{id:item.id}}">
                    <img :src="item.pic?item.pic:'./../assets/img/news_img.png'" alt="">
                    <div class="news-cont">
                        <h3 class="news-title">{{item.title}}</h3>
                        <p class="news-content">{{item.content | deleteSpace}}</p>
                        <p class="news-date">{{item.dDate}}</p>
                    </div>

                </router-link>
            </li>
        </ul>
        <loading :isloading="bOk" />
        <toast :msg="msg"/>
        <!-- <div class="addmore-box">
            <button @click="upnewdata" v-if="form.page!=pageCount" class="addmore">加载更多</button>
        </div> -->

        
    </div>
</template>
<script>
import Loading from '@/components/Loading';
import Toast from '@/components/Toast';
export default {
  name: "news",
  components:{Loading,Toast},
  filters:{
      deleteSpace(val){
          
          return val.replace(/&nbsp;/g,'');
      }
  },
  data() {
    return {
      newslist: [],
      pageCount:2,
      isloading:false,
      msg:'',
      nav: [
        {
          text: "公司新闻",
          newsclass: 1
        },
        {
          text: "行业新闻",
          newsclass: 2
        }
      ],
      bOk:false,
      ismore:false,
      form: {
        page: 1,
        page_size: 10,
        newsclass: 1
      }
    };
  },
  methods: {
    getnewslist() {
        this.bOk=true;
      this.$http
        .get("/api/article/articleList", { params: this.form })
        .then(res => {
           this.bOk=false; 
           this.$parent.ismore=false;
          if (res.code == 1) {
            this.newslist = [...this.newslist, ...res.data.list];
            this.pageCount=res.data.pageCount;
          }else{
              this.msg=res.msg;
          }
          
          
        });
    },
    updata(newsclass) {
      this.form.newsclass = newsclass;
      this.form.page = 1;
      this.newslist = [];
      this.getnewslist();
    },
    upnewdata(){
        if(!this.bOk && this.form.page<this.pageCount){
             this.form.page += 1;
             this.getnewslist();
        }
        
    }
  },
  mounted() {
    this.getnewslist();
  },
  watch:{
      '$parent.ismore'(value){
          if(value){
              this.upnewdata();
          }
          
          

      }
  }
};
</script>
<style lang="scss">
.news-box {
    .addmore-box{
        text-align: center;
        .addmore{
            background:$backBg;
            margin:.2rem;
            border:none 0;
            padding:.2rem .4rem;
            color:#fff;
            @extend .radius;

        }
    }
  .news-list {
      padding:0 $padding;
      li{
          margin-top:.22rem;
      }
      a{
          @extend .flex;
          img{
              width:2.5rem;
              height: 1.8rem;
              display: block;
              margin-right:0.16rem;
          }
          .news-cont{
              width:4.40rem;
              .news-title{
                  @include text-overflow;
                  margin-bottom: .1rem;
                  font-size: .3rem;
                  
                  
              }
              .news-content{
                   @include text-overflow(2);
                   font-size: .24rem;
                   line-height: .42rem;
                    margin-bottom: .1rem;
              }
              .news-date{
                  text-align: right;
                  color:$fontColor;
                  font-size:.2rem;
              }
          }
          
      }
  }
}
</style>
